import { createRoot } from "react-dom/client";
import App from "./App.tsx";
// Typography — minimal weights to reduce initial payload.
// Display: Chakra Petch 600/700 · Body: IBM Plex Sans 400/600 · Data: IBM Plex Mono 400
import "@fontsource/chakra-petch/600.css";
import "@fontsource/chakra-petch/700.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-mono/400.css";
// Landing "Charcoal & Ember": Bebas Neue (display) · Barlow (body)
import "@fontsource/bebas-neue/400.css";
import "@fontsource/barlow/400.css";
import "@fontsource/barlow/600.css";
import "./index.css";
import "./i18n";

createRoot(document.getElementById("root")!).render(<App />);
